export default __webpack_public_path__ + "static/media/4image.35910722.png";